import { render } from "./CreateArticle.vue?vue&type=template&id=4b89dd85&scoped=true"
import script from "./CreateArticle.vue?vue&type=script&lang=js"
export * from "./CreateArticle.vue?vue&type=script&lang=js"

import "./CreateArticle.vue?vue&type=style&index=0&id=4b89dd85&lang=scss"
import "./CreateArticle.vue?vue&type=style&index=1&id=4b89dd85&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b89dd85"]])

export default __exports__